import { ui } from "../../../../../../../../../../interfaces/interfaces";
import { JobType } from "@utils/BasicTypes";

export const handleJobChange = (event: React.SyntheticEvent<Element, Event>, value: JobType, inputRef: any) => {
  if (value) {
    inputRef.current.focus()
  }

  ui.ProblemComboJob = value;
};

export const jobGetOptionLabel = (option: JobType) => option.jobDescription;
export const jobIsOptionEqualToValue = (option: JobType, value: JobType) => option?.jobTypeCode === value?.jobTypeCode;
